module.exports = __webpack_public_path__ + "static/how-they-operate-2ea3a6156d249ea943c25471ba765931.png";